import { useCallback } from 'react'
import { useLeaderboard } from '@/arcade'
import { useProgress } from '@/contexts/ProgressProvider'
import { computeGraceScore, type GraceMeta } from '@/game/scoring'
import { BIOME_ORDER } from '@/styles/theme'
import { LEVELS } from '@/game/levels'

export function useGraceLeaderboard(limit = 20) {
  const board = useLeaderboard(limit)
  const { save } = useProgress()

  const submitGrace = useCallback(async () => {
    const grace = computeGraceScore(save)
    const totalStars = Object.values(save.progress.levelStars).reduce((a: number, b) => a + b, 0)
    const biomesCleared = BIOME_ORDER.filter((b) =>
      LEVELS.filter((l) => l.biome === b).every((l) => save.progress.completedLevels.includes(l.index)),
    ).length
    const perfectRoutes = Object.keys(save.progress.levelBest).filter(
      (k) => save.progress.levelStars[Number(k)] === 3,
    ).length
    const meta: GraceMeta = {
      totalStars,
      biomesCleared,
      perfectRoutes,
      topBiome: save.progress.currentBiome,
    }
    return board.submit(grace, meta)
  }, [board, save])

  return { ...board, submitGrace, graceScore: computeGraceScore(save) }
}
